import { MouseEvent } from "react";
import type { PageHit } from "../../search-results/page";
import PlaceholderImage from "../../components/PlaceholderImage";
import { cn } from "../../utils/cn";
import { useResolvedImage } from "../../utils/resolveShopifyGid";
import appendHeightParam from "@/frontend/algolia/utils/appendHeightParam";

export function PageCard({ pageHit, onSelect, layout }: { pageHit: PageHit; onSelect?: (hit: PageHit) => void; layout: "vertical" | "horizontal"; }) {
  function clickHandler<T extends HTMLElement = HTMLAnchorElement>(event: MouseEvent<T>) {
    event.preventDefault()
    onSelect && onSelect(pageHit)
  }

  const featuredImageGid = pageHit?.meta?.custom?.featured_image;
  const image = useResolvedImage(featuredImageGid);
  const imageStyles = "tw-h-full tw-object-cover tw-object-center";
  const placeHolderImageStyles = cn(
    "tw-bg-search-grey/10 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
    "[&>img]:tw-p-10 [&>img]:tw-object-contain [&>img]:tw-object-center",
  );

  const commonCardStyles = "tw-pt-30 xl:tw-pt-0 xl:tw-px-0 tw-flex tw-flex-col-reverse tw-justify-end tw-gap-x-10 tw-overflow-hidden [&>span]:tw-pt-2 md:[&>span]:tw-p-2 [&>span]:tw-space-y-4 [&>span]:tw-pb-20 md:[&>span]:tw-pb-b";

  const layoutClasses = layout === "horizontal" ? "tw-bg-search-grey/10 md:tw-grid tw-grid-cols-2 md:tw-h-[250px]" : "";

  const cardClass = cn(commonCardStyles, layoutClasses);

  return (
    <a onClick={clickHandler} className={cardClass}>
      <span>
        <h3 className="tw-text-[22px] tw-font-medium tw-capitalize tw-line-clamp-3">{pageHit.title}</h3>

        <div className="tw-text-search-grey tw-line-clamp-3" dangerouslySetInnerHTML={{ __html: pageHit.body_html }}></div>
      </span>

      {image ? (
        <img src={appendHeightParam(image, 500)} alt="" className={imageStyles} onClick={clickHandler<HTMLImageElement>} />
      ) : <div className={placeHolderImageStyles}><PlaceholderImage /></div>}
    </a>
  );
};